import { render, staticRenderFns } from "./template_list.vue?vue&type=template&id=77bcf7dc&scoped=true"
import script from "./template_list.vue?vue&type=script&lang=js"
export * from "./template_list.vue?vue&type=script&lang=js"
import style0 from "./template_list.vue?vue&type=style&index=0&id=77bcf7dc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bcf7dc",
  null
  
)

export default component.exports